import { render, staticRenderFns } from "./brand2.vue?vue&type=template&id=a17cf95c"
import script from "./brand2.vue?vue&type=script&lang=js"
export * from "./brand2.vue?vue&type=script&lang=js"
import style0 from "./brand2.vue?vue&type=style&index=0&id=a17cf95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports